module.exports = __webpack_public_path__ + "img/icon_yinhang@2x.b6519c08.png";